import { AfterViewInit, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FullCalendarComponent } from 'app/calendar/full-calendar/fullcalendar.component';
import { Config } from 'app/config.const';
import { Agenda } from 'app/model/agenda';
import { Agende } from 'app/model/agende';
import { Observable } from 'rxjs/Observable';
import { ITokenStore, TokenStore } from '../angular-rest';

@Component({
	selector: 'app-home',
	templateUrl: './home.html',
	styleUrls: ['./home.css'],
})
export class HomeComponent implements AfterViewInit {

	agenda: Observable<Agenda>; // FIXME: non mi piace
	username: string;
	mobileView: boolean;

	@ViewChild(FullCalendarComponent) calendar: FullCalendarComponent;

	constructor(
		private modalService: NgbModal,
		private router: Router,
		private route: ActivatedRoute,
		private agende: Agende,
		private changeRef: ChangeDetectorRef,
		@Inject(TokenStore) tokenStore: ITokenStore
	) {
		try {
			const userInfo = JSON.parse(tokenStore.userInfo);
			this.username = userInfo['username'];
		} catch (e) {
			console.error(e);
			this.username = '';
		}

		this.agenda = Observable.combineLatest(
			this.route.params,
			this.agende,
			(params, _agende) => {
				if ('codice_fiscale' in params && 'agenda' in params) {
					const agenda = _agende.find(a => {
						return a.codice_fiscale === params.codice_fiscale &&
							a.nome === params.agenda;
					});

					if (!agenda) {
						this.router.navigateByUrl('/agende');
						return null;
					} else {
						return agenda;
					}
				} else {
					return null;
				}
			}
		);

		this.mobileView = window.innerWidth < 768;
	}

	ngAfterViewInit(): void {
		this.changeRef.detectChanges();
	}

	get copyright(): string {
		const year = (new Date()).getFullYear();
		if (year === Config.copyrightBaseYear) {
			return `${year}`;
		} else {
			return `${Config.copyrightBaseYear}-${year}`;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/home/home.ts